/* unplugin-vue-components disabled */import { render } from "./exhibitions.vue?vue&type=template&id=4410eb20&scoped=true"
import script from "./exhibitions.vue?vue&type=script&lang=js"
export * from "./exhibitions.vue?vue&type=script&lang=js"

import "./exhibitions.vue?vue&type=style&index=0&id=4410eb20&scoped=true&lang=scss"
import "./exhibitions.vue?vue&type=style&index=1&id=4410eb20&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4410eb20"]])

export default __exports__